import { IframeMessengerable } from '../IframeMessengerPlayerAbstract';
import { Deferred } from '../../Utility/Deferred';
import PlayerActions from '../enums/PlayerActions';
import { NetworkStatus, NetworkInterface } from '../interfaces/NetworkInterface';

/**
 * Mixin to add Network functionality to IframeMessengerable type
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function Networkable<TBase extends IframeMessengerable>(Base: TBase) {
    return class Networkable extends Base implements NetworkInterface {
        getNetworkStatus(): Deferred<NetworkStatus> {
            return this._invokePlayerMethod(PlayerActions.GET_NETWORK_STATUS);
        }
    };
}
